import {
    createPrimitiveComponent,
    useEditorPlugin,
    usePluginOption,
} from '@udecode/plate/react';
import React from 'react';

import { CitationPlugin } from '../../CitationPlugin';

export const useFloatingCitationPageNumberInputState = () => {
    const { getOptions } = useEditorPlugin(CitationPlugin);
    const updated = usePluginOption(CitationPlugin, 'updated');
    const ref = React.useRef<HTMLInputElement>(null);
    const focused = React.useRef(false);

    React.useEffect(() => {
        if (ref.current && updated) {
            setTimeout(() => {
                const input = ref.current;

                if (!input) return;
                if (focused.current) return;

                focused.current = true;

                const pageNumber = getOptions().pageNumber;
                input.focus();
                input.value = pageNumber;
            }, 0);
        }
    }, [getOptions, updated]);

    return {
        ref,
    };
};

export const useFloatingCitationPageNumberInput = (
    state: ReturnType<typeof useFloatingCitationPageNumberInputState>
) => {
    const { getOptions, setOption } = useEditorPlugin(CitationPlugin);

    const onChange: React.ChangeEventHandler<HTMLInputElement> =
    React.useCallback(
        (e) => {
            const pageNumber = e.target.value;
            setOption('pageNumber', pageNumber);
        },
        [setOption]
    );

    return {
        props: {
            defaultValue: getOptions().pageNumber,
            onChange,
        },
        ref: state.ref,
    };
};

export const FloatingCitationPageNumberInput = createPrimitiveComponent('input')({
    propsHook: useFloatingCitationPageNumberInput,
    stateHook: useFloatingCitationPageNumberInputState,
});
